import { createSelector, createStructuredSelector } from 'reselect';
import { subscriptionInfo } from 'selectors/subscription';
import _ from 'lodash';

export const videoCollection = (state) => state.videoCollection;

export const videoCollectionList = createSelector(videoCollection, (videoColl) =>
  _.get(videoColl, 'videoList')
);

export const videoCollectionIsLoaded = createSelector(videoCollection, (videoColl) =>
  _.get(videoColl, 'isLoaded')
);

export const needToLoadVideoCollection = createSelector(
  videoCollection,
  subscriptionInfo,
  (videoColl, subscrInfo) =>
    subscrInfo &&
    subscrInfo.collectionId &&
    !_.get(videoColl, 'isLoaded') &&
    !_.get(videoColl, 'isError') &&
    !_.get(videoColl, 'isLoading')
);

export const videoCollectionPosters = createSelector(videoCollectionList, (list) => {
  let result;
  if (list) {
    result = list
      .map((video, i) => ({
        id: i + 1,
        src: _.get(video, 'image.small', ''),
      }))
      .slice(0, 8);
  } else {
    result = [];
  }
  return result;
});

export default createStructuredSelector({
  videoCollection,
  videoCollectionList,
  videoCollectionIsLoaded,
  videoCollectionPosters,
  needToLoadVideoCollection,
});
